import React, { useEffect, useState, KeyboardEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { popupOpenService } from '../../services/popupOpenService';
import { POPUP_KEY_CREATE_COOKING_STEP } from '../../constant';
import { keyDownService } from '../../services/keyDownService';
import { cookingStepSaveService } from '../../services/cookingStepSaveService';
import { CookingStep } from '../../services/recipeTypes';
import { Locale } from '../../services/commonTypes';
import { Button, Input } from '@chapche/ui';

type CreateCookingStepPopupProps = {
    onCreated?: (step: CookingStep) => void;
};

const nextStepOrder = (): number => {
    const steps = cookingStepSaveService.getSteps();
    if (!steps.length) {
        return 10;
    }
    const maxOrder = Math.max(...steps.map((step) => Number(step.stepOrder) || 0));
    return maxOrder + 10;
};

const CreateCookingStepPopup: React.FC<CreateCookingStepPopupProps> = ({ onCreated }) => {
    const { i18n } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);
    const [stepCode, setStepCode] = useState('');

    useEffect(() => {
        const open = () => {
            setIsVisible(true);
            setStepCode('');
        };
        popupOpenService.registerPopup(POPUP_KEY_CREATE_COOKING_STEP, open);
        return () => popupOpenService.unRegisterPopup(POPUP_KEY_CREATE_COOKING_STEP);
    }, []);

    const createStep = () => {
        if (!stepCode.trim()) {
            return;
        }
        cookingStepSaveService.createStep({
            stepCode: stepCode.trim(),
            stepOrder: nextStepOrder(),
            measureBlock: 'none',
            isReminder: false,
            texts: [
                { locale: Locale.LOCALE_RU, text: '' },
                { locale: Locale.LOCALE_EN, text: '' },
            ],
            conditions: [],
        }, (response) => {
            setIsVisible(false);
            onCreated?.(response);
        });
    };

    if (!isVisible) {
        return null;
    }

    return (
        <>
            <div className="modal__wrapper modal__wrapper_active" onClick={() => setIsVisible(false)}></div>
            <article
                className="modal modal_small"
                onKeyDown={(e: KeyboardEvent<HTMLElement>) => keyDownService.saveNewItem(e, createStep)}
                tabIndex={0}
            >
                <h2 className="modal__title block__title-h3">
                    {i18n.t('app.page.cookingStep.modal.create.title')}
                </h2>
                <label className="block__text recipe__form-label">
                    {i18n.t('app.page.cookingStep.stepCode')}
                    <Input
                        fullWidth
                        className="mt-0"
                        value={stepCode}
                        onChange={(e) => setStepCode(e.target.value)}
                        placeholder="rinse-grain"
                    />
                </label>
                <p className="block__content cooking-steps__create-hint">
                    {i18n.t('app.page.cookingStep.stepCodeHint')}
                </p>
                <div className="modal__button-group">
                    <Button variant="outline" onClick={() => setIsVisible(false)}>
                        {i18n.t('app.page.cookingStep.modal.cancel')}
                    </Button>
                    <Button disabled={!stepCode.trim()} onClick={createStep}>
                        {i18n.t('app.page.cookingStep.modal.create.create')}
                    </Button>
                </div>
            </article>
        </>
    );
};

export default CreateCookingStepPopup;
